/**
 * Custom Bryntum Gantt locale for Australian English (en-AU)
 * Inherits from en-US locale and overrides only Australian-specific settings:
 * - Date format: DD/MM/YYYY
 * - Time format: 12-hour with AM/PM
 * - Week starts on Monday
 * - Currency: AUD
 */

import enLocale from "@bryntum/gantt/locales/gantt.locale.En.js";

const locale = {
   ...enLocale,

   localeName: "EnAu",
   localeDesc: "English (Australia)",
   localeCode: "en-AU",
   NumberFormat: {
      locale: "en-AU",
      currency: "AUD",
   },
   DateHelper: {
      ...enLocale.DateHelper,
      locale: "en-AU",
      weekStartDay: 1,
      parsers: {
         L: "DD/MM/YYYY",
         LT: "h:mm A",
         LTS: "h:mm:ss A",
      },
   },
};

export default locale;
